import { render, staticRenderFns } from "./popup-note.vue?vue&type=template&id=3bb01dcb"
import script from "./popup-note.vue?vue&type=script&lang=js"
export * from "./popup-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports